import { State, Host, Element, Component, Prop, h, Method } from '@stencil/core';

@Component({
  tag: 'ci-dialog',
  styleUrl: 'ci-dialog.scss',
  assetsDirs: ['.../assets'],
  shadow: true,
})
export class CiDialog {
  @Element() $el: HTMLElement;
  @State() mql: MediaQueryList;
  @State() isLargeScreen: boolean = false;
  @State() showDialog: boolean = false;
  @Prop() name: string;
  private dialog: HTMLDialogElement;

  @Method()
  async closeModal(event) {
    if (this.isLargeScreen) {
      this.showDialog = false;
    } else if(event.target.tagName === 'DIALOG') {
      this.dialog.close();
    }
  }

  @Method()
  async openModal(event) {
    if (this.isLargeScreen) {
      this.showDialog = !this.showDialog;
    } else {
      event.stopPropagation();
      this.dialog.showModal();
    }
  }

  @Method()
  async forceClose() {
    this.dialog.close();
  }

  handleResize = (event: MediaQueryListEvent) => {
    this.isLargeScreen = event.matches;
    if (this.showDialog && !this.isLargeScreen) {
      this.$el.shadowRoot.querySelector('dialog')?.showModal();
    }
    if (!this.showDialog && this.isLargeScreen) {
      this.$el.shadowRoot.querySelector('dialog')?.close();
    }
  }

  componentWillLoad() {
    this.mql = window.matchMedia("(min-width: 700px)");
    this.isLargeScreen = this.mql.matches;
    this.mql.addEventListener('change', this.handleResize);
  }

  disconnectedCallback() {
    this.mql.removeEventListener('change', this.handleResize);
  }

  renderContent() {
    return [
      <div part='header' class="dialog-header">
        <button
          onClick={this.forceClose.bind(this)}
          class="dialog-close" tabindex="0" type="button" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="dialog-close-icon" focusable="false" aria-hidden="true">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.7071 5.70761C20.0976 5.31709 20.0976 4.68392 19.7071 4.29339C19.3166 3.90286 18.6834 3.90285 18.2929 4.29337L12 10.5861L5.70709 4.29337C5.31656 3.90285 4.6834 3.90286 4.29288 4.29339C3.90236 4.68392 3.90237 5.31709 4.29291 5.70761L10.5858 12.0002L4.29291 18.2929C3.90237 18.6834 3.90236 19.3166 4.29288 19.7071C4.6834 20.0976 5.31656 20.0976 5.70709 19.7071L12 13.4144L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12.0002L19.7071 5.70761Z"
              fill=""
            />
          </svg>
        </button>
        <h2 class="dialog-title">
          {this.name}
        </h2>
      </div>,
      <div part='content' class="dialog-content">
        <slot name="dialog-content" />
      </div>,
      <div part='actions' class="dialog-actions">
        <slot name="dialog-actions" />
      </div>
    ];
  }

  render() {
    return (
      <Host>
        {this.isLargeScreen ? (
          <div
            class={{
              'dialog-flyout': true,
              'dialog-flyout--open': this.showDialog
            }}>
            <div part='surface' class="dialog-surface">
              {this.renderContent()}
            </div>
          </div>
        ) : (
          <dialog
            class='dialog-overlay'
            ref={(el) => this.dialog = el}
            onClick={this.closeModal.bind(this)}
          >
            <div part='surface' class="dialog-surface">
              {this.renderContent()}
            </div>
          </dialog>
        )}
      </Host>
    );
  }
}
